import { useEffect } from 'react';
import { ApolloError } from '@apollo/client';
import Bugsnag from '../utils/bugsnag';

export const useBugsnagNotifier = (
  error: ApolloError | Error | null | undefined
): void => {
  useEffect(() => {
    if (error) Bugsnag.notify(error);
  }, [error]);
};
